import _regeneratorRuntime from 'babel-runtime/regenerator';

var _this = this;

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

import * as actions from '../../constants';
import { callAPI } from '../../middleware';
import { normaliseArrayOfObjects, getAuthToken } from '../../helpers';

var loadUserOrganisationsRequest = function loadUserOrganisationsRequest() {
  return {
    type: actions.USER_ORGANISATIONS_LOAD_REQUEST
  };
};

var loadUserOrganisationsSuccess = function loadUserOrganisationsSuccess(organisations) {
  return {
    type: actions.USER_ORGANISATIONS_LOAD_SUCCESS,
    payload: organisations
  };
};

var loadUserOrganisationsFailure = function loadUserOrganisationsFailure(error) {
  return {
    type: actions.USER_ORGANISATIONS_LOAD_FAILURE,
    error: error
  };
};

export var loadUserOrganisations = function loadUserOrganisations() {
  return function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var token, response, normalisedPayload;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              dispatch(loadUserOrganisationsRequest());
              token = getAuthToken();

              if (token) {
                _context.next = 5;
                break;
              }

              throw new Error('No user token');

            case 5:
              _context.next = 7;
              return callAPI({
                method: 'GET',
                endpoint: '/management/active-user/organisations',
                token: token
              });

            case 7:
              response = _context.sent;
              normalisedPayload = normaliseArrayOfObjects(response); // $FlowFixMe

              dispatch(loadUserOrganisationsSuccess(normalisedPayload));
              return _context.abrupt('return', true);

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](0);
              dispatch(loadUserOrganisationsFailure(_context.t0.toString()));
              console.error(_context.t0);
              return _context.abrupt('return', false);

            case 18:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 13]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};